import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { EditableImage } from "../../../header/editable/editable-image"
import { getRatio } from "../../components/column-ratio"
import { InheritedThemeProvider } from "@convertkit/editor"

const DEFAULT_IMAGE_URL =
  "https://cdn.convertkit.com/assets/placeholder-vertical.png"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-testimonial td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .ck-testimonial img {
      margin-bottom: 18px !important;
    }
  }
`

export function Testimonial({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    paddingTop: properties.verticalPadding,
    paddingRight: properties.horizontalPadding,
    paddingBottom: properties.verticalPadding,
    paddingLeft: properties.horizontalPadding,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid",
    overflow: "hidden"
  }

  return (
    <div
      className="ck-testimonial ck-layout-block-template"
      style={containerStyle}
      bgcolor={properties.backgroundColor}
    >
      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td
              width={getRatio(properties.columnRatio, "left")}
              style={{ paddingRight: 24 }}
            >
              <EditableImage
                name="image"
                src={properties.image || DEFAULT_IMAGE_URL}
                alt={properties.alt}
                width="100%"
                height="auto"
                style={{
                  maxWidth: "100%",
                  display: "block",
                  borderRadius: properties.imageBorderRadius
                }}
              />
            </td>
            <td
              width={getRatio(properties.columnRatio, "right")}
              style={{ verticalAlign: "middle", paddingRight: 24 }}
            >
              <div
                style={{
                  fontSize: "72px",
                  fontFamily: "Times New Roman",
                  lineHeight: "32px",
                  marginTop: "32px",
                  color: properties.quoteColor
                }}
              >
                “
              </div>
              <LiteSlateEditor block_id={children[0].block_id} />
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td
                      width={"8%"}
                      style={{ paddingRight: "2%", verticalAlign: "middle" }}
                    >
                      <div
                        style={{
                          color: properties.nameColor,
                          opacity: 0.25,
                          width: "100%",
                          height: "1px",
                          borderBottom: "1px solid",
                          paddingBottom: "2px"
                        }}
                      />
                    </td>
                    <td width={"90%"}>
                      <InheritedThemeProvider
                        theme={{
                          paragraph: {
                            color: properties.nameColor,
                            fontFamily: properties.headingFontFamily,
                            fontSize: 12
                          }
                        }}
                      >
                        <LiteSlateEditor block_id={children[1].block_id} />
                      </InheritedThemeProvider>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
